import { TClientIdentity } from "@ephatta/services"
import { useAdvertGetById, useRuntimeEnv } from "../../.."

export const useAdvertHasAccess = (id: string) => {
    const env = useRuntimeEnv<TClientIdentity>()
    const { data } = useAdvertGetById(id, true)

    return data?.owner?.userId === env?.userId
}